"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormulaMember["default"];
  }
});
var _FormulaMember = _interopRequireDefault(require("./FormulaMember"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }